export const vehiclesConstants = {
  GET_VEHICLES: 'GET_VEHICLES',
  GET_VEHICLES_AVAILABLES: 'GET_VEHICLES_AVAILABLES',
}
